import type { AxiosInstance } from 'axios';
import authService from './auth.service';

export interface AccreditationCategory {
  key: string;
  statement: string;
}

export interface AccreditationStatus {
  us_person: boolean;
  categories: AccreditationCategory[];
  certification: {
    category: string;
    method: string;
    certified_at: string;
    expires_at: string;
  } | null;
}

/**
 * Reg D 506(b) self-certification (option B: only US persons ever see this —
 * the backend 422s anyone else, and non-US investors never reach the flow).
 */
class AccreditationService {
  private get api(): AxiosInstance {
    return authService.getApi();
  }

  async getStatus(): Promise<AccreditationStatus> {
    const res = await this.api.get<AccreditationStatus>('/api/v1/accreditation/status');
    return res.data;
  }

  async certify(
    category: string,
    affirmations: {
      informationTrue: boolean;
      understandsRisk: boolean;
      willNotifyChanges: boolean;
    },
  ): Promise<void> {
    await this.api.post('/api/v1/accreditation/certify', {
      category,
      affirms_information_true: affirmations.informationTrue,
      affirms_understands_risk: affirmations.understandsRisk,
      affirms_will_notify_changes: affirmations.willNotifyChanges,
    });
  }
}

export default new AccreditationService();
